import React from "react";

const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { notation: n >= 100000 ? "compact" : "standard", maximumFractionDigits: 0 });

export function ProgressRing({ value = 0, target = 0, label, money: isMoney, size = 74, stroke = 8, testid }) {
  const pct = target > 0 ? Math.min(100, Math.round((value / target) * 100)) : 0;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const color = pct >= 100 ? "#10B981" : pct >= 50 ? "#F59E0B" : "#EF4444";
  const fmt = (n) => (isMoney ? inr(n) : n);
  return (
    <div className="flex flex-col items-center gap-1" data-testid={testid || `ring-${label}`}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth={stroke} />
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
            strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100}
            style={{ transition: "stroke-dashoffset .6s ease" }} />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-sm font-bold text-slate-800">{pct}%</span>
        </div>
      </div>
      <span className="text-[11px] font-semibold text-slate-600 leading-tight">{label}</span>
      <span className="text-[10px] text-slate-400">{fmt(value)}/{fmt(target)}</span>
    </div>
  );
}
